import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";

const BulkAssignFormSDV = ({
  Show,
  Hide,
  Title,
  type,
  userList,
  setSelectedIds,
  selectedIds,
  selectedSiteIds,
  setSelectedSiteIds,
  getStudyFormSDVList
}) => {
  const [assignedUser, setAssignedUser] = useState([]);
  const [reviewLoader, setReviewLoader] = useState(false);
  const [dueDate, setDueDate] = useState("");
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const bulkAssignStudySubjectFormReviewHistoryDataEntry = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to assign form field SDV reviewer!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setReviewLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.selectedIds = selectedIds
        userData.selectedSiteIds = selectedSiteIds
        userData.type = type
        userData.mode = StudyMode
        if (type === "dueDate") {
          userData.dueDate = dueDate
        }
        if (type === "assignedUser" || type === "assignedUser") {
          userData.assignedUser = assignedUser
        }
        let data = await studySiteDataEntryServices.bulkAssignStudySubjectFormReviewHistoryDataEntry(userData);
        if (data?.statusCode === 200) {
          getStudyFormSDVList();
          setSelectedIds([]);
          setSelectedSiteIds([]);
          setAssignedUser([]);
          setDueDate(getNextDate());
          Hide()
        }
      }
      setReviewLoader(false);
    });
  };

  useEffect(() => {
    setDueDate(getNextDate());
    setAssignedUser([]);
  }, [Show]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {type === "assignedUser" &&
          <Form.Group className="mb-2">
            <Form.Label>Assign User</Form.Label>
            <Form.Select
              multiple
              value={assignedUser}
              onChange={(e) => {
                const values = Array.from(
                  e.target.selectedOptions,
                  (option) => option.value
                );
                setAssignedUser(values);
              }}
            >
              {userList?.map((item, index) => (
                <option key={index} value={item?.userId}>
                  {item?.fullName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        }
        {(type === "dueDate" || type === "assignedUser") &&
          <Form.Group className="mb-2">
            <Form.Label>Due Date</Form.Label>
            <Form.Control
              type="date"
              value={dueDate}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => setDueDate(e.target.value)}
            />
          </Form.Group>
        }
      </Offcanvas.Body>
      <div className="p-2 hstack gap-2 bg-light border-top shadow-sm justify-content-end">
        <button
          className={`updateProfile`}
          onClick={bulkAssignStudySubjectFormReviewHistoryDataEntry}
          disabled={
            reviewLoader
            || !studyId
            || (type === "dueDate" ? !dueDate : (assignedUser?.length === 0 || !dueDate))
          }
          style={{ fontSize: 12 }}
        >
          {reviewLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              Assigning
            </div>
          ) : (
            type === "dueDate" ? "Assign Date" : "Assign Reviewer"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default BulkAssignFormSDV;
